// extracted by mini-css-extract-plugin
module.exports = {"content":"CeremonialMerchantInvite_index_content__NXKrs"};